import axios from 'axios';
import { SERVER_URL } from './constants.service';

const data = [{name: 'test', id: '1'}, {name: 'test2', id: '2'}];

export function getAgencies() {
  return axios.get(`${SERVER_URL}/api/Agencies?filter=%7B%22include%22%3A%22creator%22%7D`)
    .then(({ data }) => data);
}

export function getAgency(id) {
  return axios.get(`${SERVER_URL}/api/Agencies/${id}`)
    .then(({ data }) => data);
}

export function updateAgency(id, data) {
  return axios.patch(`${SERVER_URL}/api/Agencies/${id}`, data)
    .then(({ data }) => data);
}

export function getAgentsForAgency(agencyId) {
  return Promise.resolve(data);
  return axios.get(`/api/agents?agencyId=${agencyId}`)
    .then(({ data }) => data);
}

export default { getAgencies, getAgency, getAgentsForAgency, updateAgency };



// WEBPACK FOOTER //
// ./src/modules/services/agency.service.js